import { ICopyable } from '../../core/copyable.interface';

export class Results<T extends ICopyable<T>> {
    value: T[];
    totalCount: number;
    resultCount: number;

    public static getCopyFrom<T extends ICopyable<T>>(type: new () => T, other: any) {
        let instance = new Results<T>();
        instance.value = (<[]>other.value).map((x) => {
            let instance = new type();
            instance.copyFrom(x);
            return instance;
        });
        instance.totalCount = other.totalCount;
        instance.resultCount = other.resultCount;
        return instance;
    }

    public static createInstance<T>(c: new () => T): T {
        return new c();
    }

    public static empty<T extends ICopyable<T>>(type: new () => T): Results<T> {
        let instance = new Results<T>();
        instance.value = [];
        instance.totalCount = 0;
        instance.resultCount = 0;
        return instance;
    }
}
